<template>
    <div class="bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
        <div class="-ml-4 -mt-2 flex items-center justify-between flex-wrap sm:flex-nowrap px-4 py-5 sm:p-6">
            <div class="ml-4 mt-2">
                <h3 class="text-lg leading-6 font-medium text-gray-900">Location</h3>
            </div>
        </div>
    
        <div class="px-4 py-5 sm:p-6">

            <AssetManageLocation
                :asset="vehicle_asset"
                :seller_account_id="vehicle_asset?.seller_account_id"
                :auctioneer_id="vehicle_asset?.auctioneer_id"
                :buyer_account_id="vehicle_asset?.buyer_account_id"
                :current_location_id="state.current_location_id"
                :no_location_label="'I\'ll add this later'"
                v-on:new_current_location_id="locationUpdated"
            >
                <legend class="text-base font-medium text-gray-900 mb-4">Where is the vehicle now?</legend>
            </AssetManageLocation>

        </div>
    
        <div class="px-4 py-4 sm:px-6 text-right">
            <Button type="button" width="w-auto" color="blue-outline" :onClick="VEHICLE.activatePrevStep">Back</Button>
            <Button type="button" width="w-auto" class="ml-2" :onClick="() => submitStep()" :disabled="!next_button_active">Next</Button>
        </div>
    </div>
</template>

<script>
import { useVehicleStore } from '@sto/vehicle.store'
import { useSystemStore } from '@sto/system.store'
import * as AssetService from '@ser/asset'
import * as OrganisationService from '@ser/organisation'
import { computed, onMounted, onBeforeMount, reactive, watch } from 'vue'
import LoadingIcon from '@ico/LoadingIcon.vue'
import CheckIcon from '@ico/CheckIcon.vue'
import { isValid, getPayload, poundsToPence } from '@lib/helpers'
import { useRoute } from 'vue-router'
import config from '@/config'

import AssetManageLocation from '@par/asset/AssetManageLocation.vue'
export default {
    components: {
        LoadingIcon,
        CheckIcon,
        AssetManageLocation
    },
    setup() {
        const VEHICLE = useVehicleStore()
        const SYSTEM_STORE = useSystemStore()
        const ROUTE = useRoute()

        const vehicle_id = computed(() => {
            return VEHICLE?.vehicle?.id || null
        })

        const vehicle_data = computed(() => {
            return VEHICLE?.vehicle || null
        })

        const vehicle_asset_id = computed(() => {
            return VEHICLE?.vehicle?.asset?.id || null
        })

        const vehicle_asset = computed(() => {
            return VEHICLE?.vehicle?.asset || null
        })

        const next_button_active = computed(() => {
            return state.current_location_id != null
        })

        const state = reactive({
            custody_with: 'scope_organisation',
            custody_organisation_id: null,
            current_location_id: null,
            asset: null,
            locations: []
        })

        const vehicle_form = reactive({
            fields: {
                origin_location_notes: {
                    active: true,
                    label: 'Other location',
                    type: 'textarea',
                    value: '',
                    stored_value: '',
                    required: false,
                    pristine: true,
                    valid: false,
                    message: '',
                    validation: [],
                    notes: '',
                    editable: false,
                    disabled: false
                },
            }
        })

        const getAsset = async () => {
            try {
                state.asset = await AssetService.show(vehicle_asset_id.value)
                state.locations = await OrganisationService.locations(ROUTE.params.organisation_id)

                // assign the existing location id if there is one
                state.current_location_id = state.asset?.location?.id || null

                // look for *this* organisation in the assets custody array
                const scope_custody_organisation = Array.isArray(state.asset?.custody_organisations) ? state.asset.custody_organisations.find(o => o.id == ROUTE.params.organisation_id && o.status == 'active') : null
                // set the state according to who has custody
                state.custody_with = scope_custody_organisation ? 'scope_organisation' : 'other_organisation'

                let custody_organisation = scope_custody_organisation
                if (!custody_organisation) {
                    custody_organisation = Array.isArray(state.asset?.custody_organisations) ? state.asset.custody_organisations.find(o => o.status == 'active') : null
                }

                state.custody_organisation_id = custody_organisation?.id || null

            } catch (error) {
                console.error('asset data error', error)
            }
        }

        const submitStep = async () => {
            
            try {
                if (state.current_location_id && state.current_location_id != 'OTHER') await AssetService.location(vehicle_asset_id.value, state.current_location_id, state.custody_organisation_id)
                VEHICLE.setCreateModalState(true)
            } catch (error) {
                console.error('AssetService.location error',error)
            }
        }

        const locationUpdated = current_location => {
            if (current_location == 'OTHER') return state.current_location_id = current_location
            state.current_location_id = current_location?.id || null
        }

        const setCurrentLocation = () => {
            state.current_location_id = vehicle_asset.value?.location_id
        }

        onBeforeMount(() => {
            SYSTEM_STORE.createInteraction('STEP_UPDATE', ROUTE.fullPath, 'Vehicle location step', null)
            setCurrentLocation()
        })

        watch(
            () => vehicle_asset_id.value,
            (new_value, old_value) => {
                setCurrentLocation()
            }
        )

        

        return {
            VEHICLE,
            state,
            next_button_active,
            vehicle_form,
            vehicle_asset,
            submitStep,
            locationUpdated,
        }
    }
}

</script>